<template>
  <div class="configNetPage">
    <!-- 第一部分: 基本信息 -->
    <div class="section-box">
      <ul class="base-info">
        <li v-for="item in baseMsg" :key="item.key">
          <span class="label">{{ $t(item.text) }}：</span>
          <span class="value">
            <template v-if="item.key === 'url'">
              {{ urlFn() }}
            </template>
            <template
              v-else-if="item.key === 'type' || item.key === 'config_status'"
            >
              {{ textChange(item.key, $attrs.rowData[item.key]) }}
            </template>
            <template v-else>
              <i
                :class="statusIconFn($attrs.rowData['status'])"
                :title="statusFn(item.key)"
                v-if="item.key === 'tag_id'"
              ></i>
              {{ $attrs.rowData[item.key] }}
            </template>
          </span>
        </li>
      </ul>
    </div>
    <!-- 表单 -->
    <div class="formContent">
      <NetChildren v-bind="$attrs" @listFn="listFn" />
    </div>
    <!-- 第四部分: 配置列表 -->
    <div class="section-box" v-if="listArray.length">
      <div class="list">
        <div class="listPage" v-for="item in listArray" :key="item.id">
          <span>{{ $timetransition(item['log_time']) }}</span>
          <!-- 只能输网络参数 -->
          <span>{{ $t('integration.escalation_rules') }}</span>
          <span>{{ configFn(item['step_code']) }}</span>
          <el-button
            type="text"
            size="small"
            :title="$t('public.details')"
            icon="el-icon-tickets"
            @click="configDetailFn(item)"
          ></el-button>
        </div>
      </div>
    </div>
    <!-- 命令详情 -->
    <CmdDialog
      :isShow.sync="isShow"
      v-bind="$attrs"
      :title="title"
      :cmdObj="cmdObj"
    />
  </div>
</template>

<script>
import { getConfigLogContent } from '@/api/modules/deviceUrl.js'

import NetChildren from './children/NetChildren.vue'
import CmdDialog from './children/CmdDialog.vue'
import { configStep } from '@/utils/convert'

export default {
  components: {
    NetChildren,
    CmdDialog
  },
  data () {
    return {
      dioForm: {},
      baseMsg: [
        {
          key: 'url',
          text: 'public.belong'
        },
        {
          key: 'tag_id',
          text: 'device.sensor_code'
        },
        {
          key: 'config_status',
          text: 'device.config_status'
        },
        {
          key: 'carrierName',
          text: 'public.carrier'
        },
        {
          key: 'type',
          text: 'public.type'
        },
        {
          key: 'description',
          text: 'public.table_desc'
        }
      ],
      listArray: [],
      isShow: false,
      title: '',
      cmdObj: {}
    }
  },
  mounted () {
    if (
      this.$attrs.sensorWay === 'unknown' ||
      this.$attrs.sensorWay === 'unbind'
    ) {
      this.baseMsg.splice(3, 1)
    } else {
    }
  },
  methods: {
    urlFn () {
      let url = this.$attrs.rowData.scopeName
      if (this.$attrs.rowData.sceneName) {
        url += '/' + this.$attrs.rowData.sceneName
      }
      if (this.$attrs.rowData.carrierName) {
        url += '/' + this.$attrs.rowData.carrierName
      }
      return url
    },
    textChange (key) {
      if (key === 'config_status') {
        switch (this.$attrs.rowData[key]) {
          case 0: {
            return $t('device.wait_config')
          }
          case 1: {
            return $t('device.configured')
          }
          case 2: {
            return $t('device.configured')
          }
          default:
            break
        }
      } else if (key === 'type') {
        switch (this.$attrs.rowData[key]) {
          case 1: {
            return $t('deviceType.zbp_1')
          }
          case 2: {
            return $t('deviceType.zbp_2')
          }
          case 3: {
            return $t('deviceType.lora_1')
          }
          case 4: {
            return $t('deviceType.lora_2')
          }
          case 5: {
            return $t('deviceType.zeta_1')
          }
          case 6: {
            return $t('deviceType.zeta_2')
          }
          default:
            break
        }
      } else {
        return this.rowData[key]
      }
    },
    statusFn (key) {
      return this.$attrs.rowData.status === 1
        ? this.$t('public.online')
        : this.$t('public.offline')
    },
    statusIconFn (key) {
      return key === 1 ? 'iconfont icon-wifi' : 'iconfont icon-wu-WiFi'
    },
    configFn (value) {
      return this.$t(configStep[value].title)
    },
    listFn (array) {
      this.listArray = array
    },
    configDetailFn (row) {
      this.isShow = true
      this.title = `[${row.deviceName}][${
        row.type === 'app'
          ? $t('public.escalation_rules')
          : $t('public.net_param')
      }] ${$t('integration.configuration_details')} [${this.$timetransition(row.logTime)}]`
      getConfigLogContent({ configLogId: row.id }, 'sensor').then(
        ({ result }) => {
          if (result) {
            const JsonContent = JSON.parse(result.content)
            let childrenContent = ''
            if (JsonContent.content) {
              childrenContent = JSON.parse(JsonContent.content)
            }
            let url = this.$attrs.rowData.scopeName
            if (this.$attrs.rowData.sceneName) {
              url += '/' + this.$attrs.rowData.sceneName
            }
            if (this.$attrs.rowData.carrierName) {
              url += '/' + this.$attrs.rowData.carrierName
            }
            this.cmdObj = {
              full_path: url,
              carrierName: this.$attrs.rowData.carrierName,
              device_name: JsonContent.device_name,
              device_type: JsonContent.device_type,
              status: JsonContent.status,
              step: result.stepCode,
              type: JsonContent.type,
              // 从外层获取详细
              description: this.$attrs.rowData.description,
              config_status: this.$attrs.rowData.config_status,
              // content 内容
              cmd: childrenContent.cmd,

              ...childrenContent.item
            }
          } else {
            this.cmdObj = {}
          }
        }
      )
    },
    typeChangeFn (deviceType) {
      switch (deviceType) {
        case 'zbp_1': {
          return 1
        }
        case 'zbp_2': {
          return 2
        }
        case 'lora_1': {
          return 3
        }
        case 'lora_2': {
          return 4
        }
        case 'zeta_1': {
          return 5
        }
        case 'zeta_2': {
          return 6
        }
        default:
          break
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.configNetPage {
  .section-box {
    background: #fafbfc;
    border: 1px solid #ebeef5;
    border-left: 3px solid var(--primary-color, #409eff);
    border-radius: 4px;
    padding: 14px 20px;
    margin-bottom: 16px;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.04);
  }

  .base-info {
    display: grid;
    grid-template-columns: max-content 1fr;
    column-gap: 10px;

    li {
      display: contents;
    }

    .label {
      text-align: right;
      line-height: 40px;
      color: #606266;
      font-size: 14px;
    }

    .value {
      line-height: 40px;
      color: #606266;
      font-size: 14px;
    }
  }

  .formContent {
    span {
      margin-right: 5px;
    }
  }

  .list {
    max-height: 200px;
    overflow: auto;
  }

  .listPage {
    height: 40px;
    width: 100%;
    margin-top: 15px;
    padding: 0 15px;
    box-sizing: border-box;
    border-radius: 2px;
    border: 1px solid #ccc;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}
</style>
